import { DataToInnerHtmlInterceptor, DataToTextInterceptor, DynamicElementConfigs } from '@view-app/dynamic'
import { TableElementInterceptor } from './dynamic-element/table-element-interceptor/table-element-interceptor'
import { LinkElementInterceptor } from './dynamic-element/link-element-interceptor/link-element-interceptor'
import { CheckboxListElementInterceptor } from './dynamic-element/checkbox-list-element-interceptor/checkbox-list-element-interceptor'

const CLASS_FULL_WIDTH = [ 'col-12', 'col-xs-12' ]

export const appDynamicElements: DynamicElementConfigs = [
  {
    type: 'Action',
    name: 'gpei-action',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Alert',
    name: 'gpei-alert',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Body',
    name: 'p',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Button',
    name: 'button',
    defaultClasses: 'btn btn-primary',
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Card',
    name: 'gpei-card',
    defaultClasses: 'col col-xs'
  },
  {
    type: 'CardHeader',
    name: 'gpei-card-header'
  },
  {
    type: 'CardDeck',
    name: 'div',
    defaultClasses: [
      ...CLASS_FULL_WIDTH,
      'row',
      'align-items-stretch'
    ],
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'value' } }
    ]
  },
  {
    type: 'Checkbox',
    name: 'gpei-checkbox',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'CheckboxList',
    name: 'gpei-checkbox-list',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: CheckboxListElementInterceptor }
    ]
  },
  {
    type: 'Details',
    name: 'details',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Div',
    name: 'div',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'value' } }
    ]
  },
  {
    type: 'DomModifier',
    name: 'gpei-dom-modifier'
  },
  {
    type: 'Download',
    name: 'gpei-download',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Dropdown',
    name: 'gpei-dropdown',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Form',
    name: 'gpei-form',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'GaugeChart',
    aliases: ['GaugeChartStaticZone'],
    name: 'gpei-gauge',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Heading',
    name: args => `h${ args.data.size as string }`,
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Input',
    name: 'gpei-input',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'LazyLink',
    name: 'gpei-lazy-link',
    interceptors: [
      LinkElementInterceptor,
    ]
  },
  {
    type: 'LinkV2',
    name: 'a',
    interceptors: [
      LinkElementInterceptor,
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'List',
    name: args => {
      let type = args.data?.type as string
      return type.toLowerCase() === 'ordered' ? 'ol' : 'ul'
    },
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'ListItem',
    name: 'li',
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Map',
    name: 'gpei-map',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Navigation',
    name: 'nav',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Pagination',
    aliases: ['Paginator'],
    name: 'gpei-pagination',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Paragraph',
    name: 'p',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'Span',
    name: 'span',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToInnerHtmlInterceptor, config: { name: 'value' } }
    ]
  },
  {
    type: 'PrintEventButton',
    name: 'gpei-print-event-button',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Redirect',
    name: 'gpei-redirect'
  },
  {
    type: 'Select',
    name: 'gpei-select',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Option',
    name: 'option',
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'key' } }
    ]
  },
  {
    type: 'SelectSet',
    name: 'gpei-select-set',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'SetItem',
    name: 'gpei-set-item',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Summary',
    name: 'summary',
    defaultClasses: CLASS_FULL_WIDTH,
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'TabSet',
    name: 'gpei-tab-set',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'TableV2',
    name: 'table',
    defaultClasses: 'table',
    interceptors: [
      { useClass: TableElementInterceptor, config: { defaultClasses: [ ...CLASS_FULL_WIDTH , 'table-responsive'] }}
    ]
  },
  {
    type: 'TableV2Cell',
    name: 'td',
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'TableV2Header',
    name: 'th',
    interceptors: [
      { useClass: DataToTextInterceptor, config: { name: 'text' } }
    ]
  },
  {
    type: 'TableV2Head',
    name: 'thead'
  },
  {
    type: 'TableV2Row',
    name: 'tr'
  },
  {
    type: 'Textarea',
    name: 'gpei-textarea',
    defaultClasses: CLASS_FULL_WIDTH
  },
  {
    type: 'Toast',
    name: 'gpei-toast',
    defaultClasses: CLASS_FULL_WIDTH
  }
]
